<script>
import fieldMixin from '@maison/mixins/fieldMixin';
import { useField } from '@phoenix/composables/field';
import { defineAsyncComponent } from 'vue';
import Slider from '@maison/components/organisms/Slider.vue';

const RadioField = defineAsyncComponent(() => import('@maison/components/form/fields/RadioField.vue'));
const RadioStoreCardField = defineAsyncComponent(
  () => import('@maison/components/form/fields/RadioStoreCardField.vue'),
);

export default {
  components: {
    Slider,
  },

  mixins: [fieldMixin],

  props: {
    type: {
      type: String,
      default: null,
    },
    withSlider: {
      type: Boolean,
      default: false,
    },
    sliderAriaLabel: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    radioComponent() {
      switch (this.type) {
        case 'storeCard':
          return RadioStoreCardField;
        default:
          return RadioField;
      }
    },

    sliderClasses() {
      return {
        'slider--linear': this.type === 'storeCard',
      };
    },
  },

  watch: {
    'field.options'() {
      if (this.$refs.sliderRef) {
        this.$refs.sliderRef.resetPosition();
      }
    },
  },

  methods: {
    getOptionAttrs(option) {
      return {
        name: this.field.name,
        required: this.field.required,
        scope: this.field.scope,
        ...option,
      };
    },
  },
};
</script>

<template>
  <slider v-if="withSlider" ref="sliderRef" :aria-label="sliderAriaLabel" :class="sliderClasses">
    <template #default="{ sliderId }">
      <div
        v-for="option in field.options"
        :id="`${sliderId}-${option.id}`"
        :key="`${field.id}-${option.id}`"
        class="slider__item"
        role="group"
        aria-roledescription="slide"
      >
        <component
          :is="radioComponent"
          v-model="value"
          :parent-id="field.id"
          :attrs="getOptionAttrs(option)"
          :should-validate="false"
        />
      </div>
    </template>
  </slider>

  <template v-else>
    <component
      :is="radioComponent"
      v-for="option in field.options"
      :key="`${field.id}-${option.id}`"
      v-model="value"
      :parent-id="field.id"
      :attrs="getOptionAttrs(option)"
      :should-validate="false"
    />
  </template>
</template>
